<template>
  <div class="loading">
    <section id="servicios" class="secciones seccion-blanca">
      <div class="container">
        <h1>Cargando...</h1>
        <div class="row">
          <div class="col-md-12">
            <vue-loading
              type="bars"
              color="var(--primary-bgcolor)"
              :size="{ width: '100px', height: '100px' }"
            ></vue-loading>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template';

export default {
  components: { VueLoading },
  methods: {
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scroll_inicio();
  },
};
</script>
